import classNames from 'classnames';
import { forwardRef } from 'react';
import { ProviderIcon } from 'features/calendar_connections/provider_icon';
const containerCss = "ceh70y8";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const CalendarLabel = ({
  kind,
  identifier
}) => <Container>
    <ProviderIcon provider={kind} />
    <span>{identifier}</span>
  </Container>;

require("./calendar_label.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./calendar_label.js");